import { FOLDER_ERROR, isFolderError } from '../consts/errors';

export type PublishConfirmOutcome =
  /** 보냈다. `confirmed` 는 공개 확인 창을 거쳐 보냈는가. */
  | { sent: true; confirmed: boolean }
  /** 사용자가 확인을 취소해 아무것도 보내지 않았다. 실패가 아니다. */
  | { sent: false };

/**
 * "확인값 없이 보낸다 → 서버가 `PUBLISH_CONFIRM_REQUIRED` 로 막으면 묻는다 → 확인하면 `true` 로 한 번만 다시 보낸다."
 *
 * 공개 영향(담긴 비공개 퀴즈 등)은 클라가 미리 세지 않는다 — 필요한 상태를 서버만 갖고 있고, 상세의 `items` 는
 * 한 페이지라 뒷 페이지를 놓친다. 그 밖의 오류는 그대로 던진다.
 */
export const withPublishConfirm = async ({
  send,
  ask,
  onSuspend,
  onResume,
}: {
  send: (confirmSourcePublication: boolean) => Promise<unknown>;
  ask: () => Promise<boolean>;
  /** 다이얼로그를 띄우기 직전(진행 토스트를 걷을 때). */
  onSuspend?: () => void;
  /** 확인받아 다시 보내기 직전(진행 토스트를 새로 셀 때). */
  onResume?: () => void;
}): Promise<PublishConfirmOutcome> => {
  try {
    await send(false);
    return { sent: true, confirmed: false };
  } catch (error) {
    if (!isFolderError(error, FOLDER_ERROR.PUBLISH_CONFIRM_REQUIRED)) {
      throw error;
    }
    onSuspend?.();
    if (!(await ask())) return { sent: false };
    onResume?.();
    await send(true);
    return { sent: true, confirmed: true };
  }
};
